import { EFinancingProgram } from '@if/core/types'
import { Stack, Typography } from '@mui/material'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { ActionsDialog } from '../../../components'
import { useCurrentLang, useDocumentTypes } from '../../../data/selectors/app-config-selectors'
import { DocumentRequired } from '../../../data/types/DocumentSchema'

interface Props {
  open: boolean
  data: DocumentRequired | null | undefined
  onConfirm: () => void
  onCancel: () => void
}

const DeleteDocumentRequestDialog = ({ open, data, onConfirm, onCancel }: Props) => {
  const { t } = useTranslation()
  const { financingProgramId } = useParams<{ financingProgramId: EFinancingProgram }>()
  const documentTypes = useDocumentTypes(financingProgramId)
  const lang = useCurrentLang()

  return (
    <ActionsDialog
      title={
        <Stack alignItems="center" direction="row" justifyContent="space-between" spacing={3}>
          <Typography>{t('document.deleteDocumentRequest')}</Typography>
        </Stack>
      }
      open={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      <Typography>{t('document.deleteDocumentRequestConfirmation')}</Typography>
      {data?.typeId !== undefined && (
        <>
          {documentTypes[data.typeId][lang]}
          {data.labelSuffix && ` - ${data.labelSuffix}`}
          {data.applicantType && ` - ${t(`common.${data.applicantType}`)}`}
        </>
      )}
    </ActionsDialog>
  )
}

export default memo(DeleteDocumentRequestDialog)
